import {
	type ConnectOrderEaseIntegrationMutation,
	type DeleteGrowPointIterationsMutation,
	type DeleteTenantIntegrationMutation,
	type DisconnectOrderEaseIntegrationMutation,
	type SetAccountingIntegrationConfigMutation,
	type SetAccountingLineAccountsMutation,
	type UpsertMergeCrmTenantIntegrationMutation,
	type UpsertMergeTenantIntegrationMutation,
	type UpsertMySqlTenantIntegrationMutation
} from "~/gql/mutations/integration.generated";
import { type GetSynchronizationIterationsQuery } from "~/gql/queries/growPointIntegration.generated";
import {
	type GetAccountingIntegrationConfigQuery,
	type GetIntegrationHealthQuery,
	type GetRevenueRoutingCoverageQuery
} from "~/gql/queries/mergeDevIntegration.generated";
import { type OrderEaseIntegrationQuery } from "~/gql/queries/orderEaseIntegration.generated";
import { type GetTenantIntegrationDocumentsQuery } from "~/gql/queries/tenantIntegrations.generated";

export const integrationEndpoints = {
	ConnectOrderEaseIntegration: {
		invalidatesTags: ["OrderEaseIntegration"] as AddTagTypes,
		transformResponse: (res: ConnectOrderEaseIntegrationMutation) => res
	},
	DeleteGrowPointIterations: {
		invalidatesTags: ["SynchronizationIterations"] as AddTagTypes,
		transformResponse: (res: DeleteGrowPointIterationsMutation) => res
	},
	DeleteTenantIntegration: {
		invalidatesTags: ["Tenant", "WsapiImport"] as AddTagTypes,
		transformResponse: (res: DeleteTenantIntegrationMutation) => res
	},
	DisconnectOrderEaseIntegration: {
		invalidatesTags: ["OrderEaseIntegration"] as AddTagTypes,
		transformResponse: (res: DisconnectOrderEaseIntegrationMutation) => res
	},
	GetAccountingIntegrationConfig: {
		providesTags: ["AccountingIntegrationConfig"] as AddTagTypes,
		transformResponse: (res: GetAccountingIntegrationConfigQuery) => res
	},
	GetIntegrationHealth: {
		providesTags: ["IntegrationHealth"] as AddTagTypes,
		transformResponse: (res: GetIntegrationHealthQuery) => res
	},
	GetRevenueRoutingCoverage: {
		providesTags: ["RevenueRoutingCoverage"] as AddTagTypes,
		transformResponse: (res: GetRevenueRoutingCoverageQuery) => res
	},
	GetSynchronizationIterations: {
		providesTags: ["SynchronizationIterations"] as AddTagTypes,
		transformResponse: (res: GetSynchronizationIterationsQuery) => res
	},
	GetTenantIntegrationDocuments: {
		providesTags: ["Tenant"] as AddTagTypes,
		transformResponse: (res: GetTenantIntegrationDocumentsQuery) => res
	},
	OrderEaseIntegration: {
		providesTags: ["OrderEaseIntegration"] as AddTagTypes,
		transformResponse: (res: OrderEaseIntegrationQuery) => res
	},
	SetAccountingIntegrationConfig: {
		invalidatesTags: ["AccountingIntegrationConfig", "IntegrationHealth", "RevenueRoutingCoverage"] as AddTagTypes,
		transformResponse: (res: SetAccountingIntegrationConfigMutation) => res
	},
	SetAccountingLineAccounts: {
		invalidatesTags: ["AccountingIntegrationConfig"] as AddTagTypes,
		transformResponse: (res: SetAccountingLineAccountsMutation) => res
	},
	UpsertMergeCrmTenantIntegration: {
		invalidatesTags: ["Tenant"] as AddTagTypes,
		transformResponse: (res: UpsertMergeCrmTenantIntegrationMutation) => res
	},
	UpsertMergeTenantIntegration: {
		invalidatesTags: ["Tenant"] as AddTagTypes,
		transformResponse: (res: UpsertMergeTenantIntegrationMutation) => res
	},
	UpsertMySqlTenantIntegration: {
		invalidatesTags: ["Tenant"] as AddTagTypes,
		transformResponse: (res: UpsertMySqlTenantIntegrationMutation) => res
	}
};
